/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as OfflineFormsRouteImport } from './routes/_offline-forms/route'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as IndexImport } from './routes/index'
import { Route as AuthCallbackImport } from './routes/auth/callback'
import { Route as OfflineFormsOutgrowerMonitoringQuestionnaireImport } from './routes/_offline-forms/outgrower-monitoring-questionnaire'
import { Route as OfflineFormsOutgrowerFarmerOnboardingImport } from './routes/_offline-forms/outgrower-farmer-onboarding'
import { Route as OfflineFormsFarmerOnboardingImport } from './routes/_offline-forms/farmer-onboarding'
import { Route as OfflineFormsFarmMappingImport } from './routes/_offline-forms/farm-mapping'
import { Route as AuthenticatedSettingsImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedFarmsImport } from './routes/_authenticated/farms'
import { Route as AuthenticatedFarmersImport } from './routes/_authenticated/farmers'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const OfflineFormsRouteRoute = OfflineFormsRouteImport.update({
  id: '/_offline-forms',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const OfflineFormsOutgrowerMonitoringQuestionnaireRoute =
  OfflineFormsOutgrowerMonitoringQuestionnaireImport.update({
    id: '/outgrower-monitoring-questionnaire',
    path: '/outgrower-monitoring-questionnaire',
    getParentRoute: () => OfflineFormsRouteRoute,
  } as any)

const OfflineFormsOutgrowerFarmerOnboardingRoute =
  OfflineFormsOutgrowerFarmerOnboardingImport.update({
    id: '/outgrower-farmer-onboarding',
    path: '/outgrower-farmer-onboarding',
    getParentRoute: () => OfflineFormsRouteRoute,
  } as any)

const OfflineFormsFarmerOnboardingRoute =
  OfflineFormsFarmerOnboardingImport.update({
    id: '/farmer-onboarding',
    path: '/farmer-onboarding',
    getParentRoute: () => OfflineFormsRouteRoute,
  } as any)

const OfflineFormsFarmMappingRoute = OfflineFormsFarmMappingImport.update({
  id: '/farm-mapping',
  path: '/farm-mapping',
  getParentRoute: () => OfflineFormsRouteRoute,
} as any)

const AuthenticatedSettingsRoute = AuthenticatedSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedFarmsRoute = AuthenticatedFarmsImport.update({
  id: '/farms',
  path: '/farms',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedFarmersRoute = AuthenticatedFarmersImport.update({
  id: '/farmers',
  path: '/farmers',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_offline-forms': {
      id: '/_offline-forms'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof OfflineFormsRouteImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/farmers': {
      id: '/_authenticated/farmers'
      path: '/farmers'
      fullPath: '/farmers'
      preLoaderRoute: typeof AuthenticatedFarmersImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/farms': {
      id: '/_authenticated/farms'
      path: '/farms'
      fullPath: '/farms'
      preLoaderRoute: typeof AuthenticatedFarmsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_offline-forms/farm-mapping': {
      id: '/_offline-forms/farm-mapping'
      path: '/farm-mapping'
      fullPath: '/farm-mapping'
      preLoaderRoute: typeof OfflineFormsFarmMappingImport
      parentRoute: typeof OfflineFormsRouteImport
    }
    '/_offline-forms/farmer-onboarding': {
      id: '/_offline-forms/farmer-onboarding'
      path: '/farmer-onboarding'
      fullPath: '/farmer-onboarding'
      preLoaderRoute: typeof OfflineFormsFarmerOnboardingImport
      parentRoute: typeof OfflineFormsRouteImport
    }
    '/_offline-forms/outgrower-farmer-onboarding': {
      id: '/_offline-forms/outgrower-farmer-onboarding'
      path: '/outgrower-farmer-onboarding'
      fullPath: '/outgrower-farmer-onboarding'
      preLoaderRoute: typeof OfflineFormsOutgrowerFarmerOnboardingImport
      parentRoute: typeof OfflineFormsRouteImport
    }
    '/_offline-forms/outgrower-monitoring-questionnaire': {
      id: '/_offline-forms/outgrower-monitoring-questionnaire'
      path: '/outgrower-monitoring-questionnaire'
      fullPath: '/outgrower-monitoring-questionnaire'
      preLoaderRoute: typeof OfflineFormsOutgrowerMonitoringQuestionnaireImport
      parentRoute: typeof OfflineFormsRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface AuthenticatedRouteRouteChildren {
  AuthenticatedFarmersRoute: typeof AuthenticatedFarmersRoute
  AuthenticatedFarmsRoute: typeof AuthenticatedFarmsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedFarmersRoute: AuthenticatedFarmersRoute,
  AuthenticatedFarmsRoute: AuthenticatedFarmsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface OfflineFormsRouteRouteChildren {
  OfflineFormsFarmMappingRoute: typeof OfflineFormsFarmMappingRoute
  OfflineFormsFarmerOnboardingRoute: typeof OfflineFormsFarmerOnboardingRoute
  OfflineFormsOutgrowerFarmerOnboardingRoute: typeof OfflineFormsOutgrowerFarmerOnboardingRoute
  OfflineFormsOutgrowerMonitoringQuestionnaireRoute: typeof OfflineFormsOutgrowerMonitoringQuestionnaireRoute
}

const OfflineFormsRouteRouteChildren: OfflineFormsRouteRouteChildren = {
  OfflineFormsFarmMappingRoute: OfflineFormsFarmMappingRoute,
  OfflineFormsFarmerOnboardingRoute: OfflineFormsFarmerOnboardingRoute,
  OfflineFormsOutgrowerFarmerOnboardingRoute:
    OfflineFormsOutgrowerFarmerOnboardingRoute,
  OfflineFormsOutgrowerMonitoringQuestionnaireRoute:
    OfflineFormsOutgrowerMonitoringQuestionnaireRoute,
}

const OfflineFormsRouteRouteWithChildren =
  OfflineFormsRouteRoute._addFileChildren(OfflineFormsRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof OfflineFormsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/farmers': typeof AuthenticatedFarmersRoute
  '/farms': typeof AuthenticatedFarmsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/farm-mapping': typeof OfflineFormsFarmMappingRoute
  '/farmer-onboarding': typeof OfflineFormsFarmerOnboardingRoute
  '/outgrower-farmer-onboarding': typeof OfflineFormsOutgrowerFarmerOnboardingRoute
  '/outgrower-monitoring-questionnaire': typeof OfflineFormsOutgrowerMonitoringQuestionnaireRoute
  '/auth/callback': typeof AuthCallbackRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof OfflineFormsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/farmers': typeof AuthenticatedFarmersRoute
  '/farms': typeof AuthenticatedFarmsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/farm-mapping': typeof OfflineFormsFarmMappingRoute
  '/farmer-onboarding': typeof OfflineFormsFarmerOnboardingRoute
  '/outgrower-farmer-onboarding': typeof OfflineFormsOutgrowerFarmerOnboardingRoute
  '/outgrower-monitoring-questionnaire': typeof OfflineFormsOutgrowerMonitoringQuestionnaireRoute
  '/auth/callback': typeof AuthCallbackRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_offline-forms': typeof OfflineFormsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/farmers': typeof AuthenticatedFarmersRoute
  '/_authenticated/farms': typeof AuthenticatedFarmsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_offline-forms/farm-mapping': typeof OfflineFormsFarmMappingRoute
  '/_offline-forms/farmer-onboarding': typeof OfflineFormsFarmerOnboardingRoute
  '/_offline-forms/outgrower-farmer-onboarding': typeof OfflineFormsOutgrowerFarmerOnboardingRoute
  '/_offline-forms/outgrower-monitoring-questionnaire': typeof OfflineFormsOutgrowerMonitoringQuestionnaireRoute
  '/auth/callback': typeof AuthCallbackRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/farmers'
    | '/farms'
    | '/settings'
    | '/farm-mapping'
    | '/farmer-onboarding'
    | '/outgrower-farmer-onboarding'
    | '/outgrower-monitoring-questionnaire'
    | '/auth/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/farmers'
    | '/farms'
    | '/settings'
    | '/farm-mapping'
    | '/farmer-onboarding'
    | '/outgrower-farmer-onboarding'
    | '/outgrower-monitoring-questionnaire'
    | '/auth/callback'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_offline-forms'
    | '/login'
    | '/_authenticated/farmers'
    | '/_authenticated/farms'
    | '/_authenticated/settings'
    | '/_offline-forms/farm-mapping'
    | '/_offline-forms/farmer-onboarding'
    | '/_offline-forms/outgrower-farmer-onboarding'
    | '/_offline-forms/outgrower-monitoring-questionnaire'
    | '/auth/callback'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  OfflineFormsRouteRoute: typeof OfflineFormsRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  OfflineFormsRouteRoute: OfflineFormsRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/_offline-forms",
        "/login",
        "/auth/callback"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/farmers",
        "/_authenticated/farms",
        "/_authenticated/settings"
      ]
    },
    "/_offline-forms": {
      "filePath": "_offline-forms/route.tsx",
      "children": [
        "/_offline-forms/farm-mapping",
        "/_offline-forms/farmer-onboarding",
        "/_offline-forms/outgrower-farmer-onboarding",
        "/_offline-forms/outgrower-monitoring-questionnaire"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_authenticated/farmers": {
      "filePath": "_authenticated/farmers.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/farms": {
      "filePath": "_authenticated/farms.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings.tsx",
      "parent": "/_authenticated"
    },
    "/_offline-forms/farm-mapping": {
      "filePath": "_offline-forms/farm-mapping.tsx",
      "parent": "/_offline-forms"
    },
    "/_offline-forms/farmer-onboarding": {
      "filePath": "_offline-forms/farmer-onboarding.tsx",
      "parent": "/_offline-forms"
    },
    "/_offline-forms/outgrower-farmer-onboarding": {
      "filePath": "_offline-forms/outgrower-farmer-onboarding.tsx",
      "parent": "/_offline-forms"
    },
    "/_offline-forms/outgrower-monitoring-questionnaire": {
      "filePath": "_offline-forms/outgrower-monitoring-questionnaire.tsx",
      "parent": "/_offline-forms"
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
